import './Summary.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import { useFieldFast } from '../../../../../../common/Form/hooks';
import { SUMMARY_TABLE_LABELS } from '../../constants';
import ErrorsSection from '../../ErrorsSection/ErrorsSection/ErrorsSection';
import type { SetCPScheduleFormValues } from '../../types';
import { CpScheduleFormFields } from '../../types';
import { mapCustomPacingErrors } from '../../utils/errors';
import SummaryTable from './SummaryTable';
import { mapPacingImpressionToPreview, mapSummarizationToPreview } from './utils';

const [block, element] = bem('summary');

const Summary = (): React.JSX.Element => {
  const [{ value: summary }] = useFieldFast<SetCPScheduleFormValues[CpScheduleFormFields.Summary]>(
    CpScheduleFormFields.Summary
  );
  const [{ value: errorList }] = useFieldFast<SetCPScheduleFormValues[CpScheduleFormFields.ErrorList]>(
    CpScheduleFormFields.ErrorList
  );

  if (!summary)
    return (
      <div className={element('no-summary-container')}>
        <p>{SUMMARY_TABLE_LABELS.NO_SUMMARY_AVAILABLE}</p>
      </div>
    );

  const { pacingImpressionHeaders, pacingImpressionData } = mapPacingImpressionToPreview(summary);
  const summarizationData = mapSummarizationToPreview(summary);

  const mappedErrorItems = mapCustomPacingErrors(errorList || []);

  return (
    <div className={block()}>
      <SummaryTable
        title={SUMMARY_TABLE_LABELS.PACING_IMPRESSION_TABLE_TITLE}
        headers={pacingImpressionHeaders}
        data={pacingImpressionData}
      />
      <div className={element('summarize-wrap')}>
        <SummaryTable title={SUMMARY_TABLE_LABELS.SUMMARIZE_TABLE_TITLE} data={summarizationData} />
      </div>
      {mappedErrorItems.length > 0 && <ErrorsSection errorItems={mappedErrorItems} />}
    </div>
  );
};

export default Summary;
